import axios from "axios";
import { farmSatelliteSubscriptionApi, satelliteAnalyticsViewApi, satelliteTableViewApi, satelliteTableViewEnquiryApi, satelliteTableViewEnquiryStatsApi, sendSatelliteReportSpecificApi, userFarmDataApi } from "../constants/apis";
import { getUserToken } from "../helpers/local_storage_helpers";


export const postNewSatelliteFarm = async (data) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };
    const response = await axios.post(farmSatelliteSubscriptionApi, data, config);
    return response;
};

export const patchSatelliteFarm = async (id, data) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };
    const response = await axios.patch(farmSatelliteSubscriptionApi + id + "/", data, config);
    return response;
};


export const getSatelliteFarms = async (query) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(satelliteTableViewEnquiryApi + "?page_size=50&" + query ?? "", config);

    return response;
};

export const getSatelliteApprovedFarms = async (query) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(satelliteTableViewApi + "?page_size=50&" + query ?? "", config);

    return response;
};

export const getSatelliteAnalytics = async () => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(satelliteTableViewEnquiryStatsApi, config);

    return response;
};

export const getSatelliteApprovedAnalytics = async () => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(satelliteAnalyticsViewApi, config);

    return response;
};

export const patchFarmLatLng = async (id, data) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };
    const response = await axios.patch(userFarmDataApi + id + "/", data, config);
    return response;
};

export const sendSatelliteReport = async (id) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };
    const response = await axios.post(sendSatelliteReportSpecificApi, { farm_id: id }, config);
    return response;
};